import { render, staticRenderFns } from "./ProjectRecordCard.vue?vue&type=template&id=b3bd0970&scoped=true&"
import script from "./ProjectRecordCard.vue?vue&type=script&lang=js&"
export * from "./ProjectRecordCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRecordCard.vue?vue&type=style&index=0&id=b3bd0970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd0970",
  null
  
)

export default component.exports